import { IonButton, IonCol, IonIcon, IonInput, IonRow } from "@ionic/react";
import "./CodeInput.css";
import { arrowBackOutline } from "ionicons/icons";
import { useRef, useState } from "react";

interface CodeInputProps {
  digits: string[];
  setDigits: (value: string[]) => void;
}

const CodeInput: React.FC<CodeInputProps> = ({ digits, setDigits }) => {
  const inputsRef = useRef<(HTMLIonInputElement | null)[]>([]);

  const handleChange = (index: number, e: any) => {
    const value = e.detail.value;
    if (!/^\d$/.test(value) && value !== "") return;

    const newDigits = [...digits];
    newDigits[index] = value;
    setDigits(newDigits);

    if (value && index < 6) {
      inputsRef.current[index + 1]?.setFocus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === "Backspace" && !digits[index] && index > 0) {
      inputsRef.current[index - 1]?.setFocus(); // Retour au précédent
    }
  };
  return (
    <IonRow className="CodeInput-container">
      {digits.map((digit, index) => (
        <div key={index}>
          <IonInput
            ref={(el) => (inputsRef.current[index] = el)}
            type="tel"
            maxlength={1}
            value={digit}
            onIonInput={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className="CodeInput-input"
            inputMode="numeric"
          />
        </div>
      ))}
    </IonRow>
  );
};

export default CodeInput;
